export const DEFAULT_PLACE_HOLDER = 'N/A';
export const TBD = null;
